// extracted by mini-css-extract-plugin
export default {"app":"NotFound_app__saa92","text_container":"NotFound_text_container__cJb8B","cactus":"NotFound_cactus__MsAo0"};